import {
    AIF_LOGIN_RESPONSE, AIF_LOGIN_FAIL, RESET_FORGOT_PASSWORD_AIF_FAIL, RESET_FORGOT_PASSWORD_AIF_RESPONSE
} from '../types/aifLogin';

const initialState = {
    aifState: [],
    resetPasswordAIFState: {}
    // error: '',
}

export default function reducer(state = initialState, action) {
    switch (action.type) {

        case AIF_LOGIN_RESPONSE:
            return { ...state, aifState: action.payload }
        case AIF_LOGIN_FAIL:
            return { ...state, aifState: action.payload }
        case RESET_FORGOT_PASSWORD_AIF_RESPONSE:
            return { ...state, resetPasswordAIFState: action.payload }
        case RESET_FORGOT_PASSWORD_AIF_FAIL:
            return { ...state, resetPasswordAIFState: action.payload }
        default:
            return state
    }

}
